// ABOUTME: Shared game status display utilities.
// ABOUTME: Maps GameDtoStatus enum values to friendly labels and MUI chip colors.
import { GameDtoStatus } from '../api/generated'

export const STATUS_LABEL: Record<GameDtoStatus, string> = {
  [GameDtoStatus.DRAFT]: 'Draft',
  [GameDtoStatus.OPEN]: 'Accepting Players',
  [GameDtoStatus.ACTIVE]: 'In Progress',
  [GameDtoStatus.ENDED]: 'Finished',
}

export const STATUS_COLOR: Record<GameDtoStatus, 'default' | 'primary' | 'success'> = {
  [GameDtoStatus.DRAFT]: 'default',
  [GameDtoStatus.OPEN]: 'primary',
  [GameDtoStatus.ACTIVE]: 'success',
  [GameDtoStatus.ENDED]: 'default',
}
